import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeRequestNumberToStringPipe'
})
export class TypeRequestNumberToStringPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case 0: return 'Afiliación Titular';
      case 1: return 'Cambio estado civil';
      case 2: return 'Retiro Beneficiario';
      case 3: return 'Retiro Trabajador';
      case 4: return 'Afiliación Beneficiario';
      case 5: return 'Solicitud discapacidad';
      case 6: return 'ACM';
      case 8: return 'Novedad cuota monetaria';
      case 9: return 'Novedad Discapacidad';
    }
    return value;
  }
}
